import { library } from '@fortawesome/fontawesome-svg-core';

import {
  faBars,
  faRocket,
  faLightbulb,
  faUsers,
  faPhoneAlt,
  faEnvelope,
  faPaperPlane,
  faMapMarkerAlt,
  faLaptopHouse,
  faUsersCog,
  faLayerGroup,
  faLaptopCode,
  faSlidersH,
  faCogs,
  faHeadset
} from '@fortawesome/free-solid-svg-icons';

library.add(
  faBars,
  faRocket,
  faLightbulb,
  faUsers,
  faPhoneAlt,
  faEnvelope,
  faPaperPlane,
  faMapMarkerAlt,
  faLaptopHouse,
  faUsersCog,
  faLayerGroup,
  faLaptopCode,
  faSlidersH,
  faCogs,
  faHeadset
);
